module.exports = __webpack_public_path__ + "static/q16-e58efb422f99b43f527709541b00e78e.png";